import React from "react";
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import BookTestSection from "./components/BookTestSection";

const BookTestDrive = () => {
  return (
    <div>
      <Header preclass="modified" modifiedHeader={true} />
      <BookTestSection />
      <Footer />
    </div>
  );
};

export default BookTestDrive;
